import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FormFooter from '../../../common/forms/FormFooter';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';

const validateToMonth = (value, allValues) => {
  if (!value || !allValues.fromMonthString) {
    return undefined;
  }

  return value < allValues.fromMonthString
    ? 'El mes final no puede ser anterior al inicial'
    : undefined;
};

export const DRIVER_TASK_SUMMARY_MONTHLY_FORM = 'DriverTaskSummaryMonthlyForm';

const DriverTaskSummaryMonthlyForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Mes inicio" required>
        <Field
          name="fromMonthString"
          component={TextInput}
          type="month"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Mes fin">
        <Field
          name="toMonthString"
          component={TextInput}
          type="month"
          validate={[validateToMonth]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonColor="primary"
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonDisabled={loading}
    />
  </Form>
);

DriverTaskSummaryMonthlyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DriverTaskSummaryMonthlyForm.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  loading: TrafficUnit.DriverTaskSummary.getIn(['monthly', 'loading']),
});

const formComponent = reduxForm({
  form: DRIVER_TASK_SUMMARY_MONTHLY_FORM,
})(DriverTaskSummaryMonthlyForm);

export default connect(mapStateToProps, null)(formComponent);